import ExploreCategory from "./sidebar/filters/components/category";
import ExploreSearch from "@modules/new-explore/sidebar/filters/components/search";
import ExploreType from "./sidebar/filters/components/type";
import ExploreResultType from "./sidebar/filters/components/result-type";
import ExploreDuration from "./sidebar/filters/components/duration";
import ExploreCost from "./sidebar/filters/components/cost";
import ExplorePublishStatus from "./sidebar/filters/components/publish-status";
import {
  COURSE_COST,
  EXPLORE_CERTIFICATE,
  EXPLORE_DURATION,
  EXPLORE_SLUG,
  EXPLORE_STATUS,
} from "types/api/explore";
import { COURSE_TYPE } from "@types";
import { ExploreFilterSchemaType } from "./types";
import CategoryMobile from "./sidebar/filters/components/category-mobile";
import { EXPLORE_COST } from "enums/new-explore/explore-cost";
import { EXPLORE_SORT_QUERY } from "enums/new-explore/explore-sort";
import { EXPLORE_BOUGHT } from "enums/new-explore/explore-bought";
import InstructorFilter from "./sidebar/filters/components/instructor";
import InstructorFilterMobile from "./sidebar/filters/components/instructor-mobile";
import ExploreCertificateStatus from "./sidebar/filters/components/certificate_status";
import ExploreBoughtStatus from "./sidebar/filters/components/bought_status";
import { ParsedUrlQuery } from "querystring";

export const HIDDEN_PARAMS_URL = ["bought", "count"];

export const filterSelectorPerSlug = {
  [EXPLORE_SLUG.COURSE]: [
    "slug",
    "term",
    "category_id",
    "type",
    "duration",
    "cost",
    "publish_status",
    "instructor_id",
    "certificate",
    "bought",
  ],
  [EXPLORE_SLUG.INSTRUCTOR]: ["slug", "term"],
  [EXPLORE_SLUG.LANDING]: ["slug", "term"],
};

const SLUG_SHARED_FILTERS = ["slug", "term"] as const;
const NO_CHIP_FILTERS = ["bought"] as const;

export const hasNonSharedExploreFilters = (query: ParsedUrlQuery) =>
  filterSelectorPerSlug[EXPLORE_SLUG.COURSE].some((key) => {
    if (
      [...SLUG_SHARED_FILTERS, ...NO_CHIP_FILTERS].includes(
        key as (typeof SLUG_SHARED_FILTERS)[number]
      )
    )
      return false;
    const value = query[key];
    if (value == null || value === "") return false;
    if (Array.isArray(value) && value.filter(Boolean).length === 0)
      return false;
    return true;
  });

export const EXPLORE_HIDDEN_PARAMS = ["sort", "page", "slug"];

export const exploreFilterSchema: ExploreFilterSchemaType = {
  slug: {
    id: "slug",
    label: "نتایج جستجو",
    active: true,
    showMobile: false,
    data: [
      {
        name: EXPLORE_SLUG.COURSE,
        selected: true,
        persian_name: "آموزش‌ها",
      },
      {
        name: EXPLORE_SLUG.INSTRUCTOR,
        selected: true,
        persian_name: "پروفایل مدرس",
      },
      {
        name: EXPLORE_SLUG.LANDING,
        selected: true,
        persian_name: "مجموعه‌های آموزشی",
      },
    ],
    desktopComponent: ExploreResultType,
    inAccordian: true,
  },
  term: {
    id: "term",
    label: "جستجو در نتایج",
    active: true,
    showMobile: false,
    // desktopComponent: ExploreSearch,
    desktopComponent: undefined,
    data: undefined,
    inAccordian: true,
  },
  bought: {
    id: "bought",
    label: "وضعیت خرید",
    active: true,
    data: [
      {
        name: EXPLORE_BOUGHT.INCLUDE,
        selected: true,
        persian_name: "همه آموزش‌ها",
      },
    ],
    showMobile: true,
    desktopComponent: ExploreBoughtStatus,
    inAccordian: false,
  },
  certificate: {
    id: "certificate",
    label: "وضعیت گواهینامه",
    active: true,
    data: [
      {
        name: EXPLORE_CERTIFICATE.WITH,
        selected: false,
        persian_name: "دارای گواهینامه",
      },
    ],
    showMobile: true,
    desktopComponent: ExploreCertificateStatus,
    inAccordian: false,
  },
  category_id: {
    id: "category_id",
    label: "انتخاب دسته‌بندی",
    active: true,
    data: [],
    showMobile: true,
    desktopComponent: ExploreCategory,
    mobileComponent: CategoryMobile,
    inAccordian: true,
  },
  type: {
    id: "type",
    label: "نوع آموزش",
    active: false,
    showMobile: true,
    data: [
      {
        name: COURSE_TYPE.COURSE,
        persian_name: "آموزش‌های ویدئویی",
        count: undefined,
        selected: false,
      },
      {
        name: `${COURSE_TYPE.AUDIOBOOK},${COURSE_TYPE.PODCAST}`,
        persian_name: "پادکست‌ها و آموزش‌های صوتی ",
        count: undefined,
        selected: false,
      },
      {
        name: COURSE_TYPE.EXAM,
        persian_name: "آزمون‌ها",
        count: undefined,
        selected: false,
      },
      // {
      //   name: COURSE_TYPE.NOTE,
      //   persian_name: "درس متنی",
      //   count: undefined,
      //   selected: false,
      // },
    ],
    desktopComponent: ExploreType,
    inAccordian: true,
  },
  duration: {
    id: "duration",
    label: "مدت زمان",
    active: false,
    showMobile: true,
    data: [
      {
        persian_name: "کمتر از  ۱ ساعت",
        name: EXPLORE_DURATION.LESS_THAN_ONE_HOUR,
        selected: false,
        count: undefined,
      },
      {
        persian_name: "۱ تا ۳ ساعت",
        name: EXPLORE_DURATION.ONE_HOUR_TO_THREE_HOUR,
        selected: true,
        count: undefined,
      },
      {
        persian_name: "۳ تا ۵ ساعت",
        name: EXPLORE_DURATION.THREE_HOURS_TO_FIVE_HOURS,
        selected: false,
        count: undefined,
      },
      {
        persian_name: "بیش از ۵ ساعت",
        name: EXPLORE_DURATION.MORE_THAN_FIVE_HOURS,
        selected: false,
        count: undefined,
      },
    ],
    desktopComponent: ExploreDuration,
    inAccordian: true,
  },
  cost: {
    id: "cost",
    label: "هزینه آموزش",
    active: false,
    showMobile: true,
    data: [
      {
        name: COURSE_COST.FREE,
        selected: false,
        persian_name: "رایگان",
        count: 0,
      },
      {
        name: COURSE_COST.NOT_FREE,
        selected: false,
        persian_name: "غیررایگان",
        count: 0,
      },
    ],
    desktopComponent: ExploreCost,
    inAccordian: true,
  },
  publish_status: {
    id: "publish_status",
    label: "وضعیت انتشار",
    active: false,
    showMobile: true,
    data: [
      {
        name: EXPLORE_STATUS.PUBLISHED,
        selected: false,
        persian_name: "منتشر شده",
      },
      {
        name: EXPLORE_STATUS.UNPUBLISHED,
        selected: false,
        persian_name: "در فرآیند انتشار",
      },
    ],
    desktopComponent: ExplorePublishStatus,
    inAccordian: true,
  },
  instructor_id: {
    id: "instructor_id",
    label: "انتخاب مدرس",
    active: false,
    data: undefined,
    showMobile: true,
    desktopComponent: InstructorFilter,
    mobileComponent: InstructorFilterMobile,
    inAccordian: true,
  },
};

export const oldFilterConverter: {
  [key: string]: { key: string; value?: any };
} = {
  keyword: {
    key: "term",
  },
  is_free: {
    key: "cost",
    value: {
      true: EXPLORE_COST.FREE,
      false: EXPLORE_COST.NOT_FREE,
    },
  },
  category_ids: {
    key: "category_id",
  },
  instructor_ids: {
    key: "instructor_id",
  },
  status: {
    key: "publish_status",
    value: {
      publishing: EXPLORE_STATUS.UNPUBLISHED,
    },
  },
  orderby: {
    key: "sort",
    value: {
      popularity: EXPLORE_SORT_QUERY.POPULAR,
      created_time: EXPLORE_SORT_QUERY.NEWEST,
      views: EXPLORE_SORT_QUERY.TREND_COUNT,
    },
  },
};
